import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-multimedia-manager-dialog-url',
  templateUrl: './multimedia-manager-dialog-url.component.html',
  styleUrls: ['./multimedia-manager-dialog-url.component.scss']
})
export class MultimediaManagerDialogUrlComponent implements OnInit {

  url: string;
  type: string;

  constructor(private dialogRef: MatDialogRef<MultimediaManagerDialogUrlComponent>) {
  }

  ngOnInit() {
  }

  public upload() {
    if (this.url && this.type) {
      const type = this.isYoutubeUrl(this.url) ? 'YOUTUBE' : this.type;
      this.dialogRef.close({ url: this.url, type: type });
    }
  }

  private isYoutubeUrl(url) {
    if ((/^(https?\:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/).test(url)) {
      return true;
    }
    return false;
  }

}
